export type CommissionConfigurationTranslation = {
  action: string;
  aggregationPolicy: string;
  aggregationPolicyInfo: string;
  aggregationPolicyInfoAriaLabel: string;
  aggregationPolicyLink: string;
  category: string;
  completion: string;
  completionStatus: string;
  configurationScope: string;
  currentValue: string;
  discardChanges: string;
  inputLabel: string;
  level: string;
  newValue: string;
  noPendingChanges: string;
  noPendingChangesDescription: string;
  pendingChange: string;
  pendingChanges: string;
  pendingChangesDescription: string;
  pendingReview: string;
  pendingReviewDescription: string;
  policy: {
    MAX: string;
    SUM: string;
  };
  save: string;
  saveButton: string;
  saveChanges: string;
  value: string;
};

export const commissionConfigurationTranslation: CommissionConfigurationTranslation = {
  action: 'Akcja',
  aggregationPolicy: 'Polityka agregacji',
  aggregationPolicyInfo:
    'Przykład: ta sama osoba jest właścicielem procesu i twórcą klienta. Dwie reguły naliczają jej dla jednej oferty 100 zł z kategorii SALES i 250 zł z kategorii AMBASADOR.\n\nMAX (Najwyższa wartość): zostanie naliczone 250 zł, ponieważ wybrana zostanie wyższa kwota.\nSUM (Suma wartości): zostanie naliczone 350 zł, ponieważ obie kwoty zostaną zsumowane.',
  aggregationPolicyInfoAriaLabel: 'Wyjaśnienie polityki agregacji',
  aggregationPolicyLink: 'Zasady agregacji prowizji',
  category: 'Kategoria',
  completion: '{{completed}} z {{total}} uzupełnione',
  completionStatus: 'Status uzupełnienia',
  configurationScope: 'Zakres konfiguracji',
  currentValue: 'Bieżąca wartość',
  discardChanges: 'Odrzuć zmiany',
  inputLabel: '{{category}} — {{level}}',
  level: 'Poziom',
  newValue: 'Nowa wartość',
  noPendingChanges: 'Konfiguracja jest aktualna',
  noPendingChangesDescription: 'Wszystkie zapisane stawki są już aktywne.',
  pendingChange: 'Zmiana oczekuje',
  pendingChanges: '{{count}} zmian oczekuje na zapis',
  pendingChangesDescription: 'Wprowadź zmiany i zapisz je, aby zostały zastosowane.',
  pendingReview: '{{count}} zmian do sprawdzenia',
  pendingReviewDescription: 'Zapisz zmiany, aby zostały zastosowane.',
  policy: {
    MAX: 'Najwyższa wartość (MAX)',
    SUM: 'Suma wartości (SUM)',
  },
  save: 'Zapisz',
  saveButton: 'Zapisz {{category}} — {{level}}',
  saveChanges: 'Zapisz zmiany',
  value: 'Wartość',
};
